import { Button, Paper } from "@mui/material"
import OrderDetailedReceipt from "."
import { useRef } from "react"
import { useReactToPrint } from "react-to-print"
import { ReceiptTemplateType } from "src/graphql/quark/quark.type"

const sampleReceiptData = {
  orderNumber: "1234",
  logo: "https://ts-one-tenant-assets.s3.us-east-1.amazonaws.com/mp-uat/mp_logo.svg",
  companyName: "Acme Pharmacy",
  websiteUrl: "www.acmepharmacy.com",
  locationName: "Main Branch",
  locationAddress: "123 Main St, City",
  customerAddress: "123 Main St, City",
  orderDate: new Date().toLocaleDateString(),
  orderType: "Regular",
  customerName: "John Doe",
  customerPhone: "123-456-7890",
  items: [
    {
      name: "Panadol 500 mg 1 x 20 S",
      quantity: 2,
      unitPrice: 100,
      total: 200,
      discount: 40,
      taxExclusive: 208.69,
      taxRate: 15,
      taxAmount: 31.3,
      beforeDiscount: 240.0,
      skuCode: "PAN500"
    },
    {
      name: "Arinac 500 mg 1 x 20 S",
      quantity: 3,
      unitPrice: 90,
      total: 270,
      discount: 30,
      taxExclusive: 260.86,
      taxRate: 15,
      taxAmount: 39.13,
      beforeDiscount: 300.0,
      skuCode: "ARI500"
    },
    {
      name: "Panadol 500 mg 1 x 20 S",
      quantity: 2,
      unitPrice: 100,
      total: 200,
      discount: 40,
      taxExclusive: 208.69,
      taxRate: 15,
      taxAmount: 31.3,
      beforeDiscount: 240.0,
      skuCode: "PAN500"
    },
    {
      name: "Arinac 500 mg 1 x 20 S",
      quantity: 3,
      unitPrice: 90,
      total: 270,
      discount: 30,
      taxExclusive: 260.86,
      taxRate: 15,
      taxAmount: 39.13,
      beforeDiscount: 300.0,
      skuCode: "ARI500"
    }
  ],
  subtotal: 469.56,
  totalDiscount: 70.0,
  productDiscount: 70.0,
  tax: 70.43,
  shippingFee: 100,
  integrationFee: 1,
  total: 571.0,
  paymentMethod: "POS terminal (Bank Name)",
  transactionNumber: "1234567890",
  orderPlatformFees: [
    {
      name: "Platform Fee - Biodegradable is bag is this is is is  this is just testing",
      amount: 100
    }
  ]
}

const sampleReturnOrderPayload = {
  id: "81b639bc-0d04-495a-bc8e-0b6053100e0b",
  secondaryId: 1818,
  orderNumber: "1234",

  locationName: "Main Branch",
  locationAddress: "123 Main St, City",
  orderDate: new Date().toLocaleDateString(),
  order: null,
  items: [
    {
      id: "956ec403-4816-41f9-87c1-3fbedae9f4b9",
      name: "NUBEROL TABLET FORTE 3X5S",
      quantity: 2,
      subTotal: 113.23,
      totalPrice: 113.23,
      discount: 0,
      unitPrice: 62.91,
      lots: [
        {
          productLot: {
            taxSellingUnit: 0
          }
        }
      ]
    }
  ],
  location: null,
  totalAmount: 113.23,
  paymentMethod: "CASH",
  locationRegisterSession: {
    openedBy: {
      firstName: "Nabeel ",
      secondaryId: null,
      lastName: "Sharif"
    }
  },
  total: 113.23,
  status: "COMPLETED",
  orderPlatformFees: [
    {
      name: "Platform Fee - Biodegradable is bag is this is is is  this is just testing",
      amount: 100
    }
  ]
}

const OrderDetailReceiptDemo = () => {
  const receiptRef = useRef<HTMLDivElement>(null)

  const handlePrint = useReactToPrint({
    contentRef: receiptRef,
    pageStyle: `
      @page {
        size: 80mm auto;
        margin: 0mm;
      }
      @media print {
        body {
          margin: 0mm;
        }
        .MuiPaper-root {
          align-self: flex-start !important;
        }
      }
    `
  })

  //   @page {
  //     size: 80mm auto;
  //     margin: 0mm;
  //   }

  // @media print {
  //   .MuiPaper-root {
  //     align-self: flex-start !important;
  //   }
  // }
  return (
    <>
      <Button variant="contained" onClick={() => handlePrint()} color="primary" sx={{ mb: 2 }}>
        Print Receipt
      </Button>

      <Paper elevation={2} ref={receiptRef} sx={{ maxWidth: "90mm", mx: "auto", marginTop: 0, paddingTop: 0 }}>
        {/* Pre-map and pass as generic receiptData */}
        <OrderDetailedReceipt
          receiptData={sampleReceiptData}
          returnOrders={[sampleReturnOrderPayload]}
          // receiptRef={receiptRef}
          receiptType={ReceiptTemplateType.Template_1}
        />
      </Paper>
    </>
  )
}

export default OrderDetailReceiptDemo
